<template>
  <div>
    <div class="primary-panel--heading">
      <h3 class="h3">Reset password</h3>
    </div>

    <!-- reset password -->
    <div class="inputs-grid--full">
      <div
        data-input-module="primary-input"
        class="form-group primary-input primary-input---with-icon"
        v-bind:class="{ 'primary-input---with-error' : errors.has('email') }"
      >
        <input
          v-model="email"
          class="primary-input--field"
          id="id2"
          name="email"
          type="text"
          value
          onkeyup="this.setAttribute('value', this.value);"
          onchange="this.setAttribute('value', this.value);"
          v-validate="'required|email'" 
        >
        <label class="primary-input--label" for="id2">Enter email</label>
        <div class="primary-input--label-line-break"></div>
        <div class="primary-input--decoration"></div>
        <div class="primary-input--icon">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            width="18"
            height="18"
            viewBox="0 0 18 18"
          >
            <path
              transform="translate(-731 -21)"
              d="M739.99 21a9 9 0 1 1 .01 18 9 9 0 0 1-.01-18zm.01 16.2a7.2 7.2 0 1 0 0-14.4 7.2 7.2 0 0 0 0 14.4zm3.2-10.2c.44 0 .8.34.8.75v4.5c0 .41-.36.75-.8.75h-6.4c-.44 0-.8-.34-.8-.75v-4.5c0-.41.36-.75.8-.75zm0 1.5v-.75l-3.2 1.88-3.2-1.88v.75l3.2 1.88z"
            ></path>
          </svg>
        </div>
        <div v-show="errors.has('email')" class="primary-input--error">
          <div class="primary-input--error-text">Please enter valid email address</div>
          <div class="primary-input--error-icon"></div>
        </div>
      </div>
    </div>
    <!--./ reset password -->
    <form>
      <div class="text-center mb-3 modal-reset">
        <button type="button" v-on:click="reset" class="btn btn-primary block">Send mail</button>
      </div>
    </form>

    <div class="account">
      <a href="#" id="backtologin">&lsaquo; Back</a>
    </div>
  </div>
</template>
<script>
import * as api from "../modules/api.js";
import { mapState } from "vuex";

var me;
export default {
  name: "reset-password",
  data() {
    return {
      email: ""
    };
  },
  methods: {
    reset: function() {
      this.$validator.validate().then(result => {
        if (result) {
          this.$store.dispatch("forgot", {
            email: this.email
          });
        }
      });
    }
  }
};
</script>